/*
  Pillowz analytics, theme side. Setup: snippets/pz-analytics.liquid.
  GA4 is sent by one Shopify custom pixel ("Pillowz GA4", Settings > Customer events; source: docs/pillowz-ga4-pixel.js in this repo).
  The pixel turns Shopify's standard events into page_view, view_item, view_item_list, view_cart (/cart), search,
  begin_checkout, add_shipping_info, add_payment_info and purchase. This file adds what Shopify can't see, as custom
  events named "pz:<ga4 event>" that the pixel forwards unchanged:
  - add_to_cart / remove_from_cart for every cart change (PDP, quick buy, drawer +/−, cart page, upsell, free tins, gifts),
    found by diffing /cart.js after each change, so Shopify's own product_added_to_cart is ignored by the pixel
  - view_item on strength/pack change, view_cart when the drawer opens, view_item_list/select_item for homepage grids
  - Pillowz events (age gate, email popup, flavor, bundle, Buy 3 Get 2, gifts, free shipping, homepage, X offer)
  QA: ?debug_mode=1 sets a qa=1 cookie (every event gets debug_mode, the cart gets pz_qa=1 so the pixel skips purchase),
  ?debug_mode=2 is the same but still sends purchase with debug_mode (for checking purchase in DebugView; the GA4
  "QA developer traffic" filter keeps it out of reports and Google Ads), ?debug_mode=0 clears it.
  A cart note containing "QA" or "test order" also marks the cart pz_qa=1.
  No personal data (email, name, phone, address) ever goes into an event or a cart attribute.
*/
(function () {
  if (window.pzTrack) return;
  var cfg = window.PZA || {};
  var DAY = 864e5, TTL = 90;

  function cookie(name) {
    var m = document.cookie.match('(?:^|; )' + name + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var exp = new Date(Date.now() + days * DAY).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + exp + '; path=/; SameSite=Lax';
  }

  // ---------- QA mode ----------
  var query = new URLSearchParams(location.search);
  var dm = query.get('debug_mode');
  if (dm === '1' || dm === '2') setCookie('qa', dm, 30);
  if (dm === '0') setCookie('qa', '', -1);
  var QA = cookie('qa') === '1' || cookie('qa') === '2' ? cookie('qa') : '';

  // ---------- events ----------
  // pzTrack(name, params, done): done runs shortly after the event is handed to the pixel, for events fired right before leaving.
  var queue = [];
  function publish(name, p) {
    var a = window.Shopify && window.Shopify.analytics;
    if (!a || !a.publish) return false;
    a.publish('pz:' + name, p);
    return true;
  }
  window.pzTrack = function (name, params, done) {
    if (cfg.designMode) { if (done) done(); return; }
    var p = {};
    for (var k in (params || {})) if (params[k] !== undefined && params[k] !== null && params[k] !== '') p[k] = clean(params[k]);
    if (!publish(name, p)) queue.push([name, p]);
    if (done) setTimeout(done, 400);
  };
  (function flush(n) {
    if (!queue.length && n > 0) return;
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      queue.splice(0).forEach(function (e) { publish(e[0], e[1]); });
    }
    if (n < 40) setTimeout(function () { flush(n + 1); }, 250);
  })(0);
  // Inline snippets that run before this file (pz-x-offer) leave events in window.pzQ
  (window.pzQ || []).forEach(function (e) { window.pzTrack(e[0], e[1]); });
  window.pzQ = { push: function (e) { window.pzTrack(e[0], e[1]); } };

  // Drop anything that looks like an email or a phone number (not plain digit ids such as variant ids)
  function clean(v) {
    if (Array.isArray(v)) return v;
    if (typeof v !== 'string') return v;
    if (/@/.test(v) || /(\+\d{1,2}[\s.-]?)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}/.test(v)) return '(redacted)';
    return v.slice(0, 100);
  }

  // ---------- items (same shape as the pixel builds) ----------
  // item_id = variant id, item_variant = "6MG / Single Tin" or "6MG / 5-Pack Roll"
  function variantLabel(t) {
    if (!t || t === 'Default Title') return '';
    return String(t).split(' / ').map(function (p) {
      p = p.trim();
      if (/^\d+(\.\d+)?\s*mg$/i.test(p)) return p.replace(/\s+/g, '').toUpperCase();
      if (/^single (can|tin)$/i.test(p)) return 'Single Tin';
      return p;
    }).join(' / ');
  }
  function money(cents) { return Math.round(cents) / 100; }
  function cartItem(line, qty) {
    var props = line.properties || {};
    var free = !!props._pz_free, gift = !!props._pz_gift;
    var it = {
      item_id: String(line.variant_id),
      item_name: line.product_title,
      item_variant: variantLabel(line.variant_title),
      item_brand: 'Pillowz',
      price: free || gift ? 0 : money(line.final_price),
      quantity: qty
    };
    if (free) it.item_category2 = 'free_tin';
    if (gift) it.item_category2 = 'gift';
    return it;
  }
  function itemsValue(items) {
    return Math.round(items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0) * 100) / 100;
  }
  cfg.variantLabel = variantLabel;

  // ---------- cart watcher: add_to_cart / remove_from_cart for every path ----------
  // Before an add, callers may set PZA.ctx = { item_list_name: 'cart_upsell' } to label it; it applies to the next change only.
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var snap = null, cartCurrency = 'USD', cartNote = '', diffTimer = null;
  function lineKey(l) {
    var p = l.properties || {};
    return l.variant_id + (p._pz_free ? '|free' : '') + (p._pz_gift ? '|gift' : '');
  }
  function snapshot(c) {
    var s = {};
    c.items.forEach(function (l) {
      var k = lineKey(l);
      if (s[k]) s[k].qty += l.quantity; else s[k] = { qty: l.quantity, line: l };
    });
    return s;
  }
  var nativeFetch = window.fetch.bind(window);
  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function readCart(c) {
    cartCurrency = c.currency || cartCurrency;
    if ((c.note || '') !== cartNote) { cartNote = c.note || ''; syncAttrs(); }
  }
  function diff(addsOnly) {
    getCart().then(function (c) {
      readCart(c);
      var next = snapshot(c), prev = snap || {};
      snap = next;
      var ctx = cfg.ctx || {};
      cfg.ctx = null;
      var adds = [], removes = [];
      Object.keys(next).forEach(function (k) {
        var d = next[k].qty - (prev[k] ? prev[k].qty : 0);
        if (d > 0) adds.push(cartItem(next[k].line, d));
      });
      Object.keys(prev).forEach(function (k) {
        var d = prev[k].qty - (next[k] ? next[k].qty : 0);
        if (d > 0) removes.push(cartItem(prev[k].line, d));
      });
      if (adds.length) {
        var a = { currency: cartCurrency, value: itemsValue(adds), items: adds };
        if (ctx.item_list_name) a.item_list_name = ctx.item_list_name;
        if (adds.some(function (i) { return i.item_category2 === 'free_tin'; })) a.free_tin = true;
        if (adds.some(function (i) { return i.item_category2 === 'gift'; })) a.gift = true;
        window.pzTrack('add_to_cart', a);
      }
      if (removes.length && !addsOnly) window.pzTrack('remove_from_cart', { currency: cartCurrency, value: itemsValue(removes), items: removes });
    }).catch(function () {});
  }
  function onCartChange() {
    if (!snap) return;
    clearTimeout(diffTimer);
    diffTimer = setTimeout(diff, 300);
  }
  if (!cfg.designMode) {
    var wrappedFetch = window.fetch;
    window.fetch = function (input, init) {
      var p = wrappedFetch.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_RE.test(u) && !(init && init.pza)) p.then(function (r) { if (r.ok) onCartChange(); }, function () {});
      } catch (e) {}
      return p;
    };
    var xOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try { if (CART_RE.test(String(u))) this.addEventListener('load', onCartChange); } catch (e) {}
      return xOpen.apply(this, arguments);
    };
    // Plain form posts to /cart/add reload the page; compare against the cart kept from the previous page.
    // Only adds count here: a cart emptied by a finished checkout is not a removal.
    var start = function () {
      getCart().then(function (c) {
        readCart(c);
        var cur = snapshot(c), saved = null;
        try { saved = JSON.parse(sessionStorage.getItem('pza-cart') || 'null'); } catch (e) {}
        snap = saved || cur;
        if (saved && JSON.stringify(Object.keys(saved).map(function (k) { return k + saved[k].qty; })) !== JSON.stringify(Object.keys(cur).map(function (k) { return k + cur[k].qty; }))) diff(true);
        else snap = cur;
      }).catch(function () {});
    };
    window.addEventListener('pagehide', function () {
      try { if (snap) sessionStorage.setItem('pza-cart', JSON.stringify(snap)); } catch (e) {}
    });
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 2000 }); else setTimeout(start, 500);
  }
  // Full cart for view_cart (drawer); the pixel sends view_cart for /cart itself
  cfg.trackCart = function (name, c, extra) {
    var items = c.items.map(function (l) { return cartItem(l, l.quantity); });
    var p = { currency: c.currency || cartCurrency, value: itemsValue(items), items: items };
    for (var k in (extra || {})) p[k] = extra[k];
    window.pzTrack(name, p);
  };
  cfg.item = function (id, name, variantTitle, priceCents, qty) {
    return { item_id: String(id), item_name: name, item_variant: variantLabel(variantTitle), item_brand: 'Pillowz', price: money(priceCents), quantity: qty || 1 };
  };

  // ---------- product lists outside collection pages (homepage grids, recommendations) ----------
  // Collection pages get view_item_list from the pixel (Shopify's collection_viewed). Tiles carry data-pz-item="id|title|variant|price".
  function tileItem(el, i) {
    var f = (el.getAttribute('data-pz-item') || '').split('|');
    var it = cfg.item(f[0], f[1], f[2], parseInt(f[3], 10) || 0, 1);
    it.index = i;
    return it;
  }
  function listName(el) {
    var s = el.closest('[id^="shopify-section-"]');
    var id = s ? s.id.replace('shopify-section-', '').replace(/^template--\d+__/, '') : 'list';
    return (document.body.className.match(/template-(\w+)/) || [, 'page'])[1] + '_' + id.slice(0, 40);
  }
  function lists() {
    if (/\/collections\/[^/]+\/?$/.test(location.pathname)) return;
    var groups = {};
    document.querySelectorAll('[data-pz-item]').forEach(function (el) {
      var n = listName(el);
      (groups[n] = groups[n] || []).push(el);
    });
    Object.keys(groups).forEach(function (n) {
      var els = groups[n], sent = false;
      var send = function () {
        if (sent) return;
        sent = true;
        window.pzTrack('view_item_list', { item_list_name: n, items: els.slice(0, 20).map(tileItem) });
      };
      if (!('IntersectionObserver' in window)) return send();
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { send(); io.disconnect(); }
      });
      els.forEach(function (el) { io.observe(el); });
    });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pz-item] a[href*="/products/"]');
    if (!a) return;
    var el = a.closest('[data-pz-item]');
    var list = /\/collections\/[^/]+\/?$/.test(location.pathname) ? 'collection_' + location.pathname.split('/')[2] : listName(el);
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-pz-item]'));
    window.pzTrack('select_item', { item_list_name: list, items: [tileItem(el, all.indexOf(el))] });
  }, true);

  // ---------- homepage (sections/pz-hhead, pz-hpick) ----------
  // Hero and header buttons carry data-pz-cta="hero_primary|hero_secondary|header_shop_now"; flavor chips carry data-pz-hpick="<flavor>"
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var cta = e.target.closest('[data-pz-cta]');
    if (cta) window.pzTrack('hero_cta_click', { button: cta.getAttribute('data-pz-cta'), label: (cta.textContent || '').trim(), link_url: cta.getAttribute('href') });
    var chip = e.target.closest('[data-pz-hpick]');
    if (chip && chip.getAttribute('aria-selected') !== 'true') window.pzTrack('hpick_flavor_select', { flavor: chip.getAttribute('data-pz-hpick') });
  }, true);

  // ---------- age gate ----------
  // The gate opens when the ageGateAuthenticated cookie is missing (sections/age-check.liquid); accept and exit are tracked from its buttons
  function ageGateView() {
    if (cfg.designMode || cookie('ageGateAuthenticated') === 'true') return;
    if (document.querySelector('[x-data^="ThemeSection_AgeCheck"]')) window.pzTrack('age_gate_view');
  }
  function ready() { ageGateView(); lists(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();

  // ---------- email popup (Shopify Forms) ----------
  // The popup lives in <shopify-forms-embed>'s open shadow root: #app-embed holds a [role=dialog] while it is open, and
  // data-current-step moves tease → form → success. Closing removes the dialog. Only overlay forms are tracked; the email is never read.
  var seenForms = typeof WeakSet === 'function' ? new WeakSet() : null;
  function watchForm(host) {
    if (!seenForms || seenForms.has(host) || !host.shadowRoot) return;
    var root = host.shadowRoot, app = root.getElementById('app-embed');
    if (!app) return;
    seenForms.add(host);
    var open = false, done = false;
    function check() {
      if (app.getAttribute('data-layout') !== 'overlay') return;
      var step = app.getAttribute('data-current-step');
      var now = !!app.querySelector('[role="dialog"]');
      if (step === 'success' && !done) { done = true; window.pzTrack('email_signup', { method: 'popup' }); }
      if (now && !open && step === 'form') window.pzTrack('email_popup_view');
      if (!now && open && !done) window.pzTrack('email_popup_close');
      open = now;
    }
    new MutationObserver(check).observe(app, { attributes: true, childList: true, subtree: true, attributeFilter: ['data-current-step', 'data-layout'] });
    check();
  }
  function scanForms() { document.querySelectorAll('shopify-forms-embed').forEach(watchForm); }
  if (!cfg.designMode && window.MutationObserver) {
    var formTries = 0;
    (function poll() {
      scanForms();
      if (++formTries < 60) setTimeout(poll, 500);
    })();
  }

  // ---------- attribution ----------
  // First touch is kept 90 days. Last touch moves only on a new campaign or outside referrer, so browsing the site never overwrites it.
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var CLICKS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'twclid', 'ttclid', 'msclkid'];
  var SELF = /(^|\.)(pillowzpouches\.com|myshopify\.com|shopify\.com|shop\.app|paypal\.com|klarna\.com|afterpay\.com)$/i;

  function readTouch() {
    var t = {}, any = false;
    PARAMS.forEach(function (k) { var v = query.get(k); if (v) { t[k] = clean(v); any = true; } });
    CLICKS.forEach(function (k) { var v = query.get(k); if (v && !t.click) { t.click = k + ':' + v.slice(0, 250); any = true; } });
    var ref = '';
    try {
      var r = document.referrer ? new URL(document.referrer) : null;
      if (r && !SELF.test(r.hostname)) ref = r.hostname + r.pathname;
    } catch (e) {}
    if (!any && !ref) return null;
    if (ref) t.ref = ref.slice(0, 100);
    t.landing = location.pathname.slice(0, 100);
    t.time = new Date().toISOString().slice(0, 16) + 'Z';
    return t;
  }
  function getTouch(name) {
    try { return JSON.parse(cookie(name) || 'null'); } catch (e) { return null; }
  }
  function setTouch(name, t) { setCookie(name, JSON.stringify(t), TTL); }
  // Channel slug for order tags (src:facebook ...); mirrors the GA4 "Pillowz channels" group
  function channel(t) {
    if (!t) return 'direct';
    var s = (t.utm_source || '').toLowerCase(), m = (t.utm_medium || '').toLowerCase(), c = t.click || '', ref = (t.ref || '').toLowerCase();
    var paid = /paid|cpc|ppc|ads?$/.test(m);
    // Meta adds fbclid to organic link clicks too, so only UTM-tagged paid traffic counts as the Meta ad channel
    if (/^(facebook|fb|instagram|ig|meta)$/.test(s)) return paid ? 'facebook' : 'organic_social';
    if (/^(x|twitter)$/.test(s)) return paid || /^twclid/.test(c) ? 'x' : 'organic_social';
    if (/^twclid/.test(c) && !s) return 'x';
    if (/^(gclid|gbraid|wbraid)/.test(c) || s === 'google' && paid) return 'google_ads';
    if (/^fbclid/.test(c) && !s) return 'organic_social';
    if (m === 'email' || /klaviyo|shopify_email|email/.test(s)) return 'email';
    if (m === 'sms' || s === 'sms') return 'sms';
    if (/affiliate|influencer/.test(m)) return 'affiliate';
    if (/social/.test(m)) return 'organic_social';
    if (s) return 'other_campaign';
    if (/google\.|bing\.|duckduckgo\.|yahoo\.|ecosia\.|search\.brave/.test(ref)) return 'organic_search';
    if (/facebook\.|instagram\.|(^|\.)t\.co\/|twitter\.|(^|\.)x\.com|tiktok\.|reddit\.|youtube\.|pinterest\.|snapchat\./.test(ref)) return 'organic_social';
    return ref ? 'referral' : 'direct';
  }

  var now = readTouch(), first = getTouch('pz_ft'), last = getTouch('pz_lt');
  if (now) {
    if (!first) { first = now; setTouch('pz_ft', first); }
    last = now;
    setTouch('pz_lt', last);
  } else if (!first) {
    // A direct first visit still counts as a first touch
    first = { landing: location.pathname.slice(0, 100), time: new Date().toISOString().slice(0, 16) + 'Z' };
    setTouch('pz_ft', first);
  }

  // Cart attributes show on the order under Additional details; Shopify Flow tags the order from "pz_src".
  // pz_qa=1 tells the pixel not to send purchase for this order.
  function attrs() {
    var a = {}, lt = last || first;
    function put(prefix, t) {
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'click', 'ref', 'landing', 'time'].forEach(function (k) {
        a[prefix + k.replace('utm_', '')] = (t && t[k]) || '';
      });
    }
    put('ft_', first);
    put('lt_', lt);
    a.pz_src = channel(lt);
    a.pz_src_first = channel(first);
    a.pz_qa = /\b(qa|test order)\b/i.test(cartNote) ? '1' : QA;
    return a;
  }
  // Written once per change; the checkout link waits for it so the order always carries it
  var KEY = 'pza-attrs', pending = null;
  function syncAttrs(force) {
    var a = attrs(), sig = JSON.stringify(a);
    try { if (!force && sessionStorage.getItem(KEY) === sig) return Promise.resolve(); } catch (e) {}
    if (pending) return pending;
    pending = nativeFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: a })
    }).then(function (r) {
      if (r.ok) try { sessionStorage.setItem(KEY, sig); } catch (e) {}
    }).catch(function () {}).then(function () { pending = null; });
    return pending;
  }
  if (!cfg.designMode) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { syncAttrs(); }); else syncAttrs();
    var bypass = false;
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href="/checkout"], a[href^="/checkout?"], button[name="checkout"], input[name="checkout"]');
      if (!link || bypass || e.metaKey || e.ctrlKey) return;
      var saved = null;
      try { saved = sessionStorage.getItem(KEY); } catch (err) {}
      if (saved === JSON.stringify(attrs())) return;
      e.preventDefault();
      e.stopPropagation();
      var go = function () {
        bypass = true;
        if (link.href) location.href = link.href;
        else if (link.form) link.form.requestSubmit ? link.form.requestSubmit(link) : link.form.submit();
      };
      Promise.race([syncAttrs(true), new Promise(function (r) { setTimeout(r, 1500); })]).then(go);
    }, true);
  }

  cfg.qa = QA;
  cfg.channel = channel;
  cfg.attrs = attrs;
  window.PZA = cfg;
})();
